<template>
  <div class="pieCharts" :id="domId"></div>
</template>

<script>
import * as echarts from 'echarts';
import { toRefs, computed, onMounted, watch, onBeforeUnmount, ref } from 'vue';
import { getThemeColor } from '@/utils/addColor.js';

export default {
  props: {
    pieData: {
      type: Array,
      default: () => { []; }
    },
    domId: {
      type: String,
      default: () => { "pieCharts"; }
    },
    rate: {
      type: Boolean,
      default: () => { false; }
    },
    click: {
      type: Function,
      default: () => { }
    },
    chartConfig: {
      type: Object,
      default: () => { }
    }
  },
  setup(props) {
    const { pieData, chartConfig, click } = toRefs(props);
    let myChart = {};
    const themStyles = getThemeColor();
    const isClick = ref(false);
    const pieCharts = () => {
      const pieOptions = computed(() => {
        return {
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
            backgroundColor: '#11151ee5',
            padding: 16,
            textStyle: {
              color: '#eaedff'
            },
            extraCssText: 'border: 1px dotted #eaedff99',
          },
          legend: chartConfig.value || {
            type: 'scroll',
            top: 'top',
            right: '0',
            orient: 'vertical',
            icon: "circle",
            itemWidth: 13,
            itemHeight: 13,
            textStyle: {
              color: '#9FA2B1',
              fontSize: 12,
              fontWeight: 400,
              ellipsis: '...',
              overflow: 'truncate',
              width: 100,
            },
            pageIconSize: 14,
            pageButtonGap: 12,
          },
          color: themStyles["--appSafePie"]["colorList"],
          series: [
            {
              type: 'pie',
              top: "-20px",
              right: '30%',
              bottom: "-40px",
              radius: ['85%', '100%'],
              center: ['50%', '70%'],
              startAngle: 180,
              endAngle: 360,
              avoidLabelOverlap: false,
              zlevel: 1,
              label: {
                normal: {
                  padding: [2, 2, 2, 2],
                  show: false,
                  position: 'center',
                  ellipsis: '...',
                  overflow: 'truncate',
                  width: 100,
                  formatter: function ({ name, value }) { // 图例后显示值
                    let text = [`{name|${name}}`, `{value|${value}}`].join('\n');
                    if (props.rate) {
                      text = [`{name|${name}}`, `{value|${value}%}`].join('\n');
                    }
                    return text;
                  },
                  rich: {
                    value: {
                      color: '#EAEDFF',
                      fontSize: 20,
                      fontFamily: 'Azonix'
                    },
                    name: {
                      color: '#9FA2B1',
                      fontSize: 14,
                      lineHeight: 24,
                    },
                  },
                },
                emphasis: {
                  show: true,
                  offset: [0, -20],
                  textStyle: {
                    fontSize: '16',
                    fontWeight: 'bold',
                  },
                },
              },
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: pieData.value || []
            }
          ]
        };
      });
      let pieCharts = echarts.getInstanceByDom(document.getElementById(props.domId));
      if (pieCharts == null) {
        pieCharts = echarts.init(document.getElementById(props.domId));
      }
      pieCharts.setOption(pieOptions.value);
      pieCharts.on('click', () => {
        if (click) {
          // 只执行一次点击事件
          if (!isClick.value) {
            console.log(1);
            props.click();
            isClick.value = true;
          }
        }
      });

      myChart = pieCharts;
    };

    const resizeChart = () => {
      myChart.resize();
    };

    onMounted(() => {
      pieCharts();
      window.addEventListener(
        "resize", resizeChart
      );
    });

    onBeforeUnmount(() => {
      window.removeEventListener(
        "resize", resizeChart
      );
    });

    // 监听传值，刷新图表
    watch(pieData, () => {
      pieCharts();
    });
  }
}
</script>

<style scoped lang="less">
.pieCharts {
  width: 100%;
  height: 100%;
}
</style>